<template>
  <!-- <div class="mapCrudComponentOverlay">
    <div class="mapCrudComponent">
      <v-row align="center" justify="center">
  <v-card flat class="pa-4">-->
  <MapCrudFormComponent
    v-if="loaded"
    :poi="formData"
    @mapCrudFormEvent="save"
    :submited="submited"
    @resetSubmit="resetSubmit"
  ></MapCrudFormComponent>
  <!-- </v-card>
      </v-row>
    </div>
  </div>-->
</template>

<script>
import { MapDataAdapterFactory } from '../../utils/map/mapDataMutatorStrategy'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'MapCrudComponent',
  components: {
    MapCrudFormComponent: () =>
      import(/* webpackChunkName: "vts-map-crud-form-component" */ './MapCrudFormComponent')
  },
  props: {
    mapType: {
      type: String,
      required: true,
      validator: function(value) {
        // Passed prop value must match one of these strings
        return ['google', 'leaflet'].indexOf(value) !== -1
      }
    },
    mapData: {
      type: Object,
      required: true
    },
    submited: Boolean,
    closed: Boolean
  },
  data() {
    return {
      formData: null,
      loaded: false,
      notification: null,
      labels: {
        successMeassage: translate('Successfuly created POI', 'maps')
      }
    }
  },
  mounted() {
    var factory = new MapDataAdapterFactory()
    var strategy = factory.make(this.mapType)

    if (this.mapData.eventType == 'CIRCLE') {
      this.formData = this.populateCircleFormData(this.mapData.circle)
    }

    if (this.mapData.eventType == 'POLYGON') {
      this.formData = this.populateFormData(this.mapData.polygon)
    }

    /**
     * If there is an value for `id` property, it means that
     * we should show edit form.
     */
    if (this.formData.id != '') {
      this.formData.edit = true
    }

    /**
     * Populate data from dataMutator object.
     */
    let data
    if (this.mapData.dataFromEditButton) {
      if (this.mapData.eventType == 'CIRCLE') {
        data = {
          radius: this.mapData.circle._mRadius,
          coordinates: this.mapData.circle._latlng
        }
      }

      if (this.mapData.eventType == 'POLYGON') {
        data = {
          radius: this.mapData.polygon._mRadius,
          coordinates: this.mapData.polygon._latlngs
        }
      }
    } else {
      data = strategy.adapt(this.mapData)
    }

    this.formData.radius = data.radius
    this.formData.coordinates = data.coordinates

    this.loaded = true
  },
  methods: {
    populateFormData(data) {
      return {
        name: data._poiName,
        description: '',
        color: data._color,
        restriction: data._restrictionType,
        vehicleIds: data._vehicleIds,
        poiTime: data._poiTime,
        radius: '',
        coordinates: '',
        type: data._type,
        id: data._id
      }
    },
    populateCircleFormData(data) {
      return {
        name: data._poiName,
        description: '',
        color: data._color,
        restriction: data._restrictionType,
        vehicleIds: data._vehicleIds,
        poiTime: data._poiTime,
        radius: '',
        coordinates: '',
        type: data._type,
        id: data._id,
        contacts: data._contacts,
        hasParking: data._hasParking,
        objectType: data._objectType,
        unloadPlaceType: data._unloadPlaceType,
        pointOfInterestType: data._pointOfInterestType,
        partnerCode: data._partnerCode,
        hasRamp: data._hasRamp,
        hasForklift: data._hasForklift,
        specialPermitRequired: data._specialPermitRequired
      }
    },
    save(error) {
      if (!error) {
        this.notification = {
          type: 'success',
          message: this.labels.successMeassage
        }
      } else {
        this.notification = {
          type: 'error',
          message: error
        }
      }
      this.closeMapCrudComponent(this.notification)
    },
    closeMapCrudComponent(notification) {
      this.formData = {}
      this.loaded = false
      this.$emit('closeMapCrudComponent', this.notification)
    },
    resetSubmit() {
      this.$emit('resetSubmit')
    }
  },
  watch: {
    closed: {
      handler() {
        if (this.closed) {
          this.closeMapCrudComponent()
        }
      }
    }
  }
}
</script>

<style scoped>
.mapCrudComponentOverlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  overflow-x: hidden;
}

.mapCrudComponent {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
